import api from './api';

export interface RevealStatus {
  isRevealed: boolean;
  revealedAt?: string;
}

export interface RevealedCandidate {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  jobTitle: string;
  location: string;
  profilePhotoUrl?: string;
  yearsOfExperience?: number;
  revealedAt: string;
}

export interface RevealedCandidatesResponse {
  candidates: RevealedCandidate[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface SearchRevealedCandidatesParams {
  search?: string;
  page?: number;
  limit?: number;
}

class RecruiterCandidateService {
  /**
   * Check if a specific candidate's contact has been revealed
   */
  async checkRevealStatus(candidateId: string): Promise<RevealStatus> {
    const response = await api.get(`/recruiters/candidates/${candidateId}/reveal-status`);
    return response.data;
  }

  /**
   * List and search candidates whose contact has been revealed
   */
  async searchRevealedCandidates(
    params?: SearchRevealedCandidatesParams
  ): Promise<RevealedCandidatesResponse> {
    const response = await api.get('/recruiters/revealed-candidates', { params });
    return response.data;
  }
}

export default new RecruiterCandidateService();
